import React from 'react'
import logo from '../images/cocard_member_office_logo.png';
export default function Header() {
    return (
        <div className="header shadow py-4 mb-5">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="inner-header">
                            <a href="https://cocardpayments.com/">
                                <img src={logo} alt="CoCard logo" />
                            </a>
                            <p className="text-right discount mb-0">CoCard Zero Cost Processing <span className="d-wrap"><span className="new_discount">0%</span><span className="old_discount"><del>2.9% + $0.30 per swipe</del></span></span><br/><span className="float-left" style={{"color": "#797b7d", "fontSize": "13px", "marginTop": "5px"}}>NEED HELP OR HAVE QUESTIONS? <span style={{"color":"#000", "marginLeft": "6px"}}><b><a href="tel:1-888-594-2929" style={{"color": "#000"}}>1-888-594-2929</a></b> <span style={{"color":"#000", "fontSize": "7px","display":"inline-flex", "verticalAlign":"top"}}>CALL<br/>TEXT</span></span></span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
